import { render, staticRenderFns } from "./yearDetailNext.vue?vue&type=template&id=c8175508&scoped=true"
import script from "./yearDetailNext.vue?vue&type=script&lang=js"
export * from "./yearDetailNext.vue?vue&type=script&lang=js"
import style0 from "./yearDetailNext.vue?vue&type=style&index=0&id=c8175508&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8175508",
  null
  
)

export default component.exports